/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formname_Validation1Inputs */

const ja_contact_formname_validation1 = /** @type {(inputs: Contact_Formname_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このフィールドは必須です`)
};

const en_contact_formname_validation1 = /** @type {(inputs: Contact_Formname_Validation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This field is required`)
};

/**
* | output |
* | --- |
* | "This field is required" |
*
* @param {Contact_Formname_Validation1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formname_validation1 = /** @type {((inputs?: Contact_Formname_Validation1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formname_Validation1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formname_validation1(inputs)
	return en_contact_formname_validation1(inputs)
});
export { contact_formname_validation1 as "contact_formName_validation" }